import { render } from "./HomeCatalogue.vue?vue&type=template&id=0b3323fe"
import script from "./HomeCatalogue.vue?vue&type=script&lang=js"
export * from "./HomeCatalogue.vue?vue&type=script&lang=js"

import "./HomeCatalogue.vue?vue&type=style&index=0&id=0b3323fe&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__